import * as React from "react"
import { DrawerSeeker, GridSeeker, ImgS } from "ui-seeker/core"
import { formatDate, isEmpty } from 'ui-seeker/utils'

import { IMAGE } from 'app/@common/constants'
import {useContextSelector} from "use-context-selector";
import { AppCalendarEventsContext } from "../Providers";


export default function AppCalendarAlertsDrawer() {

    const monthYear = useContextSelector(AppCalendarEventsContext, ({state}) => state.monthYear)
    const monthAlerts = useContextSelector(AppCalendarEventsContext, ({state}) => state.monthAlerts)
    const updateCalendar = useContextSelector(AppCalendarEventsContext, ({ updateState }) => updateState)
    const isOpenDrawer = useContextSelector(AppCalendarEventsContext, ({state}) => state.isOpenAlertsDrawer)

    if (isEmpty(monthAlerts) || !monthYear) return null

    const todaysAlerts = Object.values(monthAlerts[monthYear] || {})

    const config = {
        isOpen: isOpenDrawer,
        controller: () => updateCalendar({ isOpenAlertsDrawer: false }),
        title: monthYear !== 0 && `${formatDate(monthYear.toString(), { isString: true, format: 'dd MMM yyyy', receivedFormat: 'yyyyMMdd' })} - ${todaysAlerts.length} ALERT NOTIFICATIONS`,
        okBtn: false, cancelBtn: false,
        size: 'md',
        className: 'drawer-form-user'
    }

    return <DrawerSeeker {...config}>
        { !!Object.keys(monthAlerts).length ? todaysAlerts.map(notification => {

            let finalString = ''
            const stringDesc = `'${notification.id_hotel_name}' hotel on the '${notification.id_site_name}' site `
            const isNA = [3, 4, 6, 8].some(arrVal => arrVal === notification.tp)

            if (isNA) {
                if (notification.comparison === 'ns')
                    finalString = stringDesc.concat(`if it doesn't have availability in its main but does have availability in its compset`)
                else
                    finalString = stringDesc.concat(`if it has availability in its main but doesn't have availability in its compset`)
            } else if (notification.comparison) {
                finalString = stringDesc.concat(`when the value is ${notification.comparison} ${`${notification.diff_percentage.toFixed(2)}% (${notification.diff_absolute.toFixed(2)} ${notification.currency})`}`)
            } else if (notification.ikey) {
                finalString = stringDesc.concat(`has the next keys: ${notification.ikey}`)
            }

            return <>
                <GridSeeker container key={notification.id_alert} size={12} className="py-8 px-4 medium-bold-text">
                    <GridSeeker size={12} style={{ color: '#313131', textAlign: 'left' }}>
                        <span className='dashTitle'>
                            {notification.date_from && <p><strong>{`${notification.nights} night${notification.nights > 1 ? 's' : ''}`} | {`${notification.adults} adult${notification.adults > 1 ? 's' : ''}${notification.kids > 0 ? (`, ${notification.kids} kid${notification.kids > 1 ? 's' : ''}`) : ''}`}</strong></p>}
                            <p>{finalString}</p>
                        </span>
                    </GridSeeker>
                </GridSeeker>
                <hr className="alert-line-separator" />
            </>
        }) : <>
            <div style={{ display: 'flex', justifyContent: 'center' }}>
                <ImgS className="image-no-data-bounce" style={{ height: '200px', opacity: 0.5, rowGap: '15px' }} src={`${IMAGE.ASSETS}/no-data-laptop.svg`} alt="No data available" />
            </div>
            <div className="text-no-results">No alerts found</div>
        </> }
    </DrawerSeeker>
}